export default __webpack_public_path__ + "static/media/logo-mapfre.ae1ffe93.webp";